import { apiClient } from './api'

export interface Account {
  id: string
  name: string
  address?: string
  ownerId: string
  ownerName?: string
  ownerEmail?: string
  parentAccountId?: string
  isActive: boolean
  usersCount?: number
  subAccountsCount?: number
  createdAt: string
  updatedAt: string
}

export interface AccountDetail extends Account {
  users: Array<{
    id: string
    name: string
    email: string
    role: string
    isActive: boolean
  }>
  subAccounts: Account[]
}

export interface CreateAccountPayload {
  name: string
  address?: string
  ownerName?: string
  ownerEmail?: string
  ownerPassword?: string
  existingOwnerId?: string
  parentAccountId?: string
  sendInvitation?: boolean
}

export function getAccounts() {
  return apiClient.get<Account[]>('/accounts')
}

export function getAccountById(id: string) {
  return apiClient.get<AccountDetail>(`/accounts/${id}`)
}

export function createAccount(data: CreateAccountPayload) {
  return apiClient.post<Account>('/accounts', data)
}

export function updateAccount(id: string, data: { name?: string; address?: string; isActive?: boolean }) {
  return apiClient.put<Account>(`/accounts/${id}`, data)
}

export function deleteAccount(id: string) {
  return apiClient.delete(`/accounts/${id}`)
}

export function transferOwnership(accountId: string, newOwnerId: string) {
  return apiClient.put(`/accounts/${accountId}/transfer-ownership`, { newOwnerId })
}

export function addUserToAccount(accountId: string, data: { name: string; email: string; password?: string; role?: string; sendInvitation?: boolean }) {
  return apiClient.post(`/accounts/${accountId}/users`, data)
}

export function inviteUserToAccount(accountId: string, data: { email: string; name?: string; role?: string }) {
  return apiClient.post(`/accounts/${accountId}/invite`, data)
}

export function migrateAccounts() {
  return apiClient.post('/accounts/migrate')
}
